import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { generatePool } from "../lib/social_pool";
import { TrendingUp, ArrowDownToLine, Sparkles, Users, RotateCcw } from "lucide-react";

const ICONS = {
  invest: TrendingUp,
  withdraw: ArrowDownToLine,
  activate: Sparkles,
  join: Users,
  reinvest: RotateCcw,
  joint: Users,
};

export default function SocialProofPopups() {
  const [current, setCurrent] = useState(null);
  const poolRef = useRef([]);
  const idxRef = useRef(0);

  useEffect(() => {
    let pool = [];
    try {
      const cached = localStorage.getItem("duo_pool_v2");
      const session = parseInt(localStorage.getItem("duo_pool_session_v2") || "0", 10);
      if (cached) pool = JSON.parse(cached);
      if (!pool.length) {
        pool = generatePool(220);
        // Shuffle so each visit feels fresh
        for (let i = pool.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [pool[i], pool[j]] = [pool[j], pool[i]];
        }
        localStorage.setItem("duo_pool_v2", JSON.stringify(pool));
      }
      localStorage.setItem("duo_pool_session_v2", String(session + 1));
      // rotate starting index by session count to avoid identical first popup
      idxRef.current = (session * 7) % pool.length;
    } catch {
      pool = generatePool(220);
    }
    poolRef.current = pool;

    let timeout;
    const showOne = () => {
      const p = poolRef.current[idxRef.current % poolRef.current.length];
      idxRef.current += 1;
      setCurrent({ ...p, k: idxRef.current });
      const visible = 5500;
      const gap = 180000 + Math.random() * 90000; // 3 min gap, ~4 min average
      timeout = setTimeout(() => {
        setCurrent(null);
        timeout = setTimeout(showOne, gap);
      }, visible);
    };
    timeout = setTimeout(showOne, 3000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="fixed bottom-6 left-6 z-40 max-w-sm pointer-events-none" data-testid="social-proof-container">
      <AnimatePresence>
        {current && (
          <motion.div
            key={current.k}
            initial={{ opacity: 0, y: 30, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.96 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="glass-strong rounded-xl p-4 shadow-2xl pointer-events-auto"
            data-testid="social-proof-popup"
          >
            <div className="flex items-start gap-3">
              <div className="text-2xl">{current.flag}</div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  {(() => {
                    const Icon = ICONS[current.type] || TrendingUp;
                    return <Icon className="w-3.5 h-3.5 text-[#00D68F]" />;
                  })()}
                  <span className="text-[10px] uppercase tracking-widest text-[#00D68F] font-bold">Live Activity</span>
                </div>
                <div className="text-sm text-white/90 leading-snug">{current.text}</div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}